import { SkeletonBlock } from '../../components/SkeletonBlock';
import { Heading, Inner, ScrollArea, Wrapper } from './ContentPanelShell.styles';
import type { ContentPanelShellProps } from './ContentPanelShell.types';

export function ContentPanelShell({
  topBar,
  heading,
  children,
  footer,
  isLoading = false,
}: ContentPanelShellProps) {
  return (
    <Wrapper aria-busy={isLoading || undefined}>
      <ScrollArea>
        <Inner>
          {topBar}
          <Heading>{isLoading ? <SkeletonBlock variant="heading" /> : heading}</Heading>
          {children}
        </Inner>
      </ScrollArea>
      {footer}
    </Wrapper>
  );
}
